import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy
} from "@angular/core";
import * as _moment from "moment/moment";
import { UserId } from "../../shared/userid.model";
import { Router } from "@angular/router";
import { ForgotService } from "src/app/shared/Forgot.Service";
import * as textMask from "vanilla-text-mask/dist/vanillaTextMask.js";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";

@Component({
  selector: "app-appointed",
  templateUrl: "./appointed.component.html",
  styleUrls: ["./appointed.component.scss"]
})
export class AppointedComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() emitter: EventEmitter<string> = new EventEmitter();
  public type: string;
  public showPlaceholder: boolean;
  public show = false;
  @Input() govid = "";
  @Input() dob: Date;
  public pasteData = "";
  error: boolean;
  message: any;
  public uuid: string;
  public isLoading = false;
  public pasteInd = "N";
  public userId: string;
  public pwd: string;
  public resp: any;
  public showId = false;
  public showpwd = false;
  public forgot: any;
  public nextStepType = "";
  public validate = true;
  public isMonth = false;
  public isDay = false;
  public isYear = false;
  public formErrorFields: any = {
    govid: false,
    govidVal: false,
    option: false,
    dob: false
  };
  public contactText: string =
    "<b>Individual Retirement Sales Desk:</b>" +
    "<br> (888) 517-9900, option 1, 3 <br> Monday - Thursday, 8:30 AM-7:00 PM (ET)" +
    "<br> Friday, 8:30 AM - 5:30 PM (ET) <br>" +
    "<br><b>401(k) Sales Desk:</b> <br> (866) 401-3030, option 1" +
    "<br> Monday - Thursday, 8:30 AM - 6:00 PM (ET)" +
    "<br>Friday, 8:30 AM - 5:00 PM (ET) <br><br> <b>403(b) Sales Desk:</b>" +
    "<br> (866) 401-3030, option 3 <br> Monday - Thursday, 8:30 AM - 6:00 PM (ET)" +
    "<br> Friday, 8:30 AM - 5:00 PM (ET) <br><br> <b>457 Sales Desk:</b>" +
    "<br> (866) 401-3030, option 6 <br> Monday - Thursday, 8:30 AM - 6:00 PM (ET)" +
    "<br> Friday, 8:30 AM - 5:00 PM (ET)";
  constructor(private router: Router, private forgotService: ForgotService) {}

  mask = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]; // mm/dd/yyyy
  maskedInputController;

  @ViewChild("input") public input: ElementRef;
  @ViewChild("ssn") public ssn: ElementRef;
  @ViewChild("option") public option: ElementRef;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maskedInputController = textMask.maskInput({
        inputElement: this.input.nativeElement,
        mask: this.mask,
        guide: false
      });
    });
  }
  ngOnDestroy() {
    this.maskedInputController.destroy();
  }

  openDate(datePicker) {
    datePicker.open();
    this.dob = null;
    (document.getElementById("dpicker") as HTMLInputElement).value = "";
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.validateForm("dob");
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.type = "password"; // display as '*'
    this.showPlaceholder = true;
    this.generateSession();
  }

  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.type = "text";
    } else {
      this.type = "password";
    }
  }
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute("placeholder", ele.getAttribute("data-placeholder"));
    } else {
      ele.setAttribute("placeholder", "");
    }
  }

  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }

  toggleForm(event: FocusEvent, model) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
    this.validateForm(model);
  }

  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }

  paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData("text");
    }
  }

  focusOnInput() {
    let setError = false;
    if (!!this.formErrorFields.option) {
      setError = true;
      window.scroll(0, 0);
      setTimeout(() => this.option.nativeElement.focus(), 0);
      setTimeout(() => this.option.nativeElement.select(), 0);
      window.scrollTo(
        0,
        this.option.nativeElement.getBoundingClientRect().top +
          window.scrollY -
          150
      );
    } else if (
      !!this.formErrorFields.govid ||
      !!this.formErrorFields.govidVal
    ) {
      setError = true;
      setTimeout(() => this.ssn.nativeElement.focus(), 0);
      setTimeout(() => this.ssn.nativeElement.select(), 0);
      window.scrollTo(
        0,
        this.ssn.nativeElement.getBoundingClientRect().top +
          window.scrollY -
          150
      );
    } else if (!!this.formErrorFields.dob) {
      setError = true;
      setTimeout(() => this.input.nativeElement.focus(), 0);
      setTimeout(() => this.input.nativeElement.select(), 0);
      window.scrollTo(
        0,
        this.input.nativeElement.getBoundingClientRect().top +
          window.scrollY -
          150
      );
    }
    return setError;
  }

  isErrorPresent() {
    if (
      !this.formErrorFields.option &&
      !this.formErrorFields.govid &&
      !this.formErrorFields.govidVal &&
      !this.formErrorFields.dob
    ) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ["nextStepType", "govid", "dob"];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      if (fields[j] === "dob") {
        let dobVal = (document.getElementById("dpicker") as HTMLInputElement)
          .value;
        isErrPresent = !this.isDatePattern(dobVal) ? true : false;
        if (isErrPresent) {
          this.formErrorFields.dob = true;
          break;
        }
      } else {
        isErrPresent = this.validateForm(fields[j]);
        if (isErrPresent) {
          break;
        }
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }

  validateForm(model) {
    let error = false;
    this.validate = true;

    if (model === "nextStepType") {
      if (
        this.nextStepType === "" ||
        this.nextStepType === undefined ||
        this.nextStepType === null
      ) {
        this.formErrorFields.option = true;
        error = true;
      } else {
        this.formErrorFields.option = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === "govid") {
      if (!this.govid || this.govid === undefined) {
        this.formErrorFields.govid = true;
        this.formErrorFields.govidVal = false;
        error = true;
      } else if (this.govid !== "" && this.govid.length !== 4) {
        this.formErrorFields.govid = false;
        this.formErrorFields.govidVal = true;
        error = true;
      } else {
        this.formErrorFields.govid = false;
        this.formErrorFields.govidVal = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === "dob") {
      const isOpen =
        document.getElementsByClassName("mat-datepicker-popup").length === 0
          ? false
          : true;
      if (isOpen) {
        return;
      }
      let textDate = (document.getElementById("dpicker") as HTMLInputElement)
        .value;
      if (textDate === "") {
        this.isMonth = this.isDay = this.isYear = false;
        this.formErrorFields.dob = false;
        this.ifAtleastOneFieldValidated(model);
      } else if (!this.isValidDate(textDate)) {
        this.formErrorFields.dob = true;
        error = true;
      } else {
        this.formErrorFields.dob = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    console.log(this.formErrorFields);
    if (
      !!this.nextStepType &&
      !!this.govid &&
      !!this.dob &&
      !this.isErrorPresent() &&
      !error
    ) {
      this.validate = error;
    }
    return error;
  }

  isDatePattern(dateString) {
    // First check for the pattern
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
      return true;
    }
  }

  //Validates that the input string is a valid date formatted as "mm/dd/yyyy"
  isValidDate(dateString) {
    // Parse the date parts to integers
    let isValid = false;
    let parts = dateString.split("/");
    let month = parseInt(parts[0], 10);
    let day = parseInt(parts[1], 10);
    let year = parseInt(parts[2], 10);

    // Check the ranges of month
    if (!isNaN(month)) {
      if (month > 12) {
        this.isMonth = false;
      } else {
        this.isMonth = true;
      }
    }

    // Check the ranges of day
    if (!isNaN(day)) {
      let monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      // Adjust for leap years
      if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
        monthLength[1] = 29;
      }

      // Check the range of the day
      if (day <= monthLength[month - 1]) {
        this.isDay = true;
      } else {
        this.isDay = false;
      }
    }

    // Check the ranges of year
    if (!isNaN(year)) {
      if (year.toString().length === 1) {
        if (
          parseInt(year.toString().charAt(0)) === 1 ||
          parseInt(year.toString().charAt(0)) === 2
        ) {
          this.isYear = true;
        } else {
          this.isYear = false;
        }
      }
      if (year.toString().length === 2) {
        if (
          (parseInt(year.toString().charAt(0)) === 1 ||
            parseInt(year.toString().charAt(0)) === 2) &&
          (parseInt(year.toString().charAt(1)) === 9 ||
            parseInt(year.toString().charAt(1)) === 0)
        ) {
          this.isYear = true;
        } else {
          this.isYear = false;
        }
      }
      if (year.toString().length === 3) {
        if (
          (parseInt(year.toString().charAt(0)) === 1 ||
            parseInt(year.toString().charAt(0)) === 2) &&
          (parseInt(year.toString().charAt(1)) === 9 ||
            parseInt(year.toString().charAt(1)) === 0) &&
          (parseInt(year.toString().charAt(2)) >= 0 ||
            parseInt(year.toString().charAt(2)) <= 9)
        ) {
          this.isYear = true;
        } else {
          this.isYear = false;
        }
      }
      if (year.toString().length === 4) {
        if (year < 1900 || year > new Date().getFullYear()) {
          this.isYear = false;
        } else {
          this.isYear = true;
        }
      }
    }

    if (
      (/^\d{1,2}$/.test(dateString) || /^\d{1,2}\/$/.test(dateString)) &&
      this.isMonth
    ) {
      isValid = true;
    }

    if (
      (/^\d{1,2}\/\d{1,2}$/.test(dateString) ||
        /^\d{1,2}\/\d{1,2}\/$/.test(dateString)) &&
      this.isMonth &&
      this.isDay
    ) {
      isValid = true;
    }

    if (
      /^\d{1,2}\/\d{1,2}\/\d{1,4}$/.test(dateString) &&
      this.isMonth &&
      this.isDay &&
      this.isYear
    ) {
      isValid = true;
    }

    if (this.formErrorFields.dob && !this.isDatePattern(dateString)) {
      return false;
    } else {
      return isValid;
    }
  }

  cancel() {
    this.router.navigate(["broker"]);
  }

  continue() {
    if (!this.validateAllFields()) {
      const user = new UserId();
      if (!this.formErrorFields.dob) {
        user.dob = _moment(this.dob).format("MM/DD/YYYY");
      }
      if (this.govid && this.pasteData === this.govid) {
        this.pasteInd = "Y";
      } else {
        this.pasteInd = "N";
      }
      user.ssn = this.govid;
      user.userType = "broker";
      const bodyString = JSON.stringify(user);
      if (this.nextStepType && this.nextStepType === "userid") {
        setTimeout(() => {
          window.scrollTo(0, 0);
          this.isLoading = true;
          this.error = false;
          this.validate = true;
        });
        this.forgotService.getUserId(bodyString).subscribe(res => {
          this.resp = res;
          if (this.resp) {
            if (this.resp.status_code !== "200") {
              setTimeout(() => {
                this.isLoading = false;
              });
              this.message = this.resp.message;
              this.error = true;
              this.validate = false;
              window.scroll(0, 0);
              if (this.resp.message) {
                this.message = this.resp.message;
              } else {
                this.message =
                  "There was an error processing your request. Please try again. If the error persists, Please call your Sales Desk for assistance.";
              }
              setTimeout(() => {
                this.maskedInputController = textMask.maskInput({
                  inputElement: this.input.nativeElement,
                  mask: this.mask,
                  guide: false
                });
              });
            } else {
              this.error = false;
              this.validate = true;
              let url = false;
              let question = false;
              if (this.resp.url && !question) {
                url = true;
                this.forgotService.setUserType(user.userType);
                this.forgotService.setQuestions(this.resp.questions);
                console.log("url " + this.resp.url);
                window.location.href = this.resp.url;
              }

              if (this.resp.questions && !url) {
                question = true;
                this.forgotService.setUserType(user.userType);
                this.forgotService.setType("uid");
                this.forgotService.setQuestions(this.resp.questions);
                this.router.navigate(["/questions"]);
              }
            }
          }
        });
      }
      if (this.nextStepType && this.nextStepType === "password") {
        setTimeout(() => {
          this.isLoading = true;
          this.error = false;
          this.validate = false;
        });
        this.forgotService
          .getBrokerPassword(
            user.dob,
            user.ssn,
            user.userType,
            this.pasteInd,
            this.nextStepType
          )
          .subscribe(res => {
            this.forgot = res;
            if (this.forgot) {
              setTimeout(() => {
                this.isLoading = false;
              });
            }
            console.log("nextStepType " + this.nextStepType);
            if (this.forgot) {
              if (
                this.forgot.status_code &&
                this.forgot.status_code !== "200"
              ) {
                this.message = this.forgot.message;
                this.error = true;
                this.validate = true;
                window.scroll(0, 0);
                if (this.forgot.message) {
                  this.message = this.forgot.message;
                } else {
                  this.message =
                    "There was an error processing your request. Please try again. If the error persists, Please call your Sales Desk for assistance.";
                }
                setTimeout(() => {
                  this.maskedInputController = textMask.maskInput({
                    inputElement: this.input.nativeElement,
                    mask: this.mask,
                    guide: false
                  });
                });
              } else {
                this.error = false;
                this.validate = true;
                /* this.forgotService.setQuestions(this.forgot.questions);
                  this.forgotService.setType('pwd');
                  this.forgotService.setUserType(user.userType);
                  this.router.navigate(['/questions']); */

                let url = false;
                let question = false;
                if (this.forgot.url && !question) {
                  url = true;
                  console.log("url " + this.forgot.url);
                  window.location.href = this.forgot.url;
                }

                if (this.forgot.questions && !url) {
                  question = true;
                  this.forgotService.setUserType(user.userType);
                  this.forgotService.setType("pwd");
                  this.forgotService.setQuestions(this.forgot.questions);
                  this.router.navigate(["/questions"]);
                }
              }
            }
          });
      }
      if (this.nextStepType && this.nextStepType === "both") {
        setTimeout(() => {
          this.isLoading = true;
          this.error = false;
          this.validate = true;
        });
        window.scroll(0, 0);
        this.forgotService
          .getBrokerPassword(
            user.dob,
            user.ssn,
            user.userType,
            this.pasteInd,
            this.nextStepType
          )
          .subscribe(res => {
            this.forgot = res;

            console.log("nextStepType " + this.nextStepType);
            if (this.forgot) {
              setTimeout(() => {
                this.isLoading = false;
              });
              if (
                this.forgot.status_code &&
                this.forgot.status_code !== "200"
              ) {
                this.message = this.forgot.message;
                this.error = true;
                this.validate = false;
                window.scroll(0, 0);
                if (this.forgot.message) {
                  this.message = this.forgot.message;
                } else {
                  this.message =
                    "There was an error processing your request. Please try again. If the error persists, Please call your Sales Desk for assistance.";
                }
                setTimeout(() => {
                  this.maskedInputController = textMask.maskInput({
                    inputElement: this.input.nativeElement,
                    mask: this.mask,
                    guide: false
                  });
                });
              } else {
                this.error = false;
                // this.forgotService.setQuestions(this.forgot.questions);
                // this.forgotService.setType('both');
                // this.forgotService.setUserType(user.userType)
                // this.router.navigate(['/questions']);

                let url = false;
                let question = false;
                if (this.forgot.url && !question) {
                  url = true;
                  console.log("url " + this.forgot.url);
                  window.location.href = this.forgot.url;
                }

                if (this.forgot.questions && !url) {
                  question = true;
                  this.forgotService.setUserType(user.userType);
                  this.forgotService.setType("both");
                  this.forgotService.setQuestions(this.forgot.questions);
                  this.router.navigate(["/questions"]);
                }
              }
            }
          });
      }
    } else {
      this.focusOnInput();
    }
  }

  generateSession() {
    this.uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function(c) {
        const r = window.crypto.getRandomValues(new Uint8Array(1))[0] & 0xf;
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    console.log("session: " + this.uuid);
  }
}
